<input
  #input
  (click)="allowTyping ? null : openPicker($event)"
  (input)="onTypedInput($any($event.target).value)"
  (focus)="onTypedFocus()"
  (blur)="onTypedBlur()"
  [attr.placeholder]="placeholder || null"
  [value]="formattedString"
  [disabled]="disabled"
  [readonly]="!allowTyping"
  autocomplete="off"
  matInput />

<input [hidden]="true" [matDatepicker]="picker" [disabled]="disabled" />

<mat-datepicker
  #picker
  panelClass="date-time-picker-panel"
  (opened)="onPickerOpened()"
  (closed)="closed.emit()">
  <mat-datepicker-actions class="customer-datepicker-actions">
    <form [formGroup]="form">
      <div class="time-picker">
        <div class="field">
          <button mat-icon-button (click)="incrementHours()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <input
            type="text"
            matInput
            formControlName="hour"
            (blur)="onTouched?.()"
            (change)="onHoursInputChange($event)" />
          <button mat-icon-button (click)="decrementHours()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        <div class="field">
          <button mat-icon-button (click)="incrementMinutes()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <input
            type="text"
            matInput
            formControlName="minute"
            (blur)="onTouched?.()"
            (change)="onMinutesInputChange($event)" />
          <button mat-icon-button (click)="decrementMinutes()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        <div class="field">
          <button mat-icon-button (click)="incrementSeconds()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <input
            type="text"
            matInput
            formControlName="second"
            (blur)="onTouched?.()"
            (change)="onSecondsInputChange($event)" />
          <button mat-icon-button (click)="decrementSeconds()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        <div class="field">
          <button mat-icon-button (click)="updateAMPM()">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </button>
          <span> {{ form.value.amPm }} </span>
          <button mat-icon-button (click)="updateAMPM()">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>
      @if (showTimeZone) {
        <mat-form-field appearance="outline" class="mat-sm time-zone-picker">
          <mat-label>TimeZone</mat-label>
          <input
            matInput
            formControlName="timeZone"
            [readonly]="lockTimeZone"
            [matAutocomplete]="autoCompleteDropdown"
            [matAutocompleteDisabled]="lockTimeZone"
            (blur)="onTouched?.()"
            (input)="formAutocompleteValueChanges()" />
          <mat-autocomplete
            #autoCompleteDropdown="matAutocomplete"
            (optionSelected)="onTimeZoneSelected($event)">
            @for (
              timezone of (filteredTimeZones$ | async) ?? [];
              track timezone.id
            ) {
              <mat-option class="time-picker-option-sm" [value]="timezone.name">
                {{ timezone.name }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (!lockTimeZone) {
            <app-field-clear-suffix
              matSuffix
              [control]="form.get('timeZone')"
              [autocomplete]="true" />
          }
        </mat-form-field>
      }

      <div class="action">
        <button
          (click)="onSubmit()"
          [disabled]="form.invalid"
          class="ibc-primary-default-button"
          mat-button>
          Ok
        </button>
      </div>
    </form>
  </mat-datepicker-actions>
</mat-datepicker>
